export const CONFIGURATION_NAV_TITLE = "Configuration";
